module.exports = __webpack_public_path__ + "static/media/map-marker-alt-slash.11e79a4a.svg";